<template>
  <div class="sla">
    <div class="head-box">
      <h4>
        SLA管理
        <span class="c_size_14" style="font-weight:normal">
          （每条流程只允许同时启用1条SLA规则）
        </span>
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入要查询的内容"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button v-if="osg.has('SLAs,new')" type="primary" @click.native="doNew" class="c-m-l-10">
          新建
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="left-box">
        <div class="left-content row">
          <div class="content-group">
            <div
              v-for="(item, i) in options.workflowDefs"
              :key="i"
              class="content-item"
              :class="item._id == currentWorkflowDefId ? 'is-selected' : ''"
              @click="
                currentWorkflowDefId = item._id;
                fpi.page = 1;
                getData();
              "
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="content-table">
        <el-table
          :data="fpi.data"
          ref="table"
          style="width: 100%"
          height="calc(100% - 50px)"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column label="SLA名称">
            <template slot-scope="scope">
              <el-button
                @click="
                  $router.push({
                    path: `/SLA/${scope.row._id}`
                  })
                "
                type="text"
              >
                {{ scope.row.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="workflowDefId"
            label="工作流"
            :formatter="formatWorkflowDefId"
          ></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.state == 1">已启用</el-tag>
              <el-tag type="warning" v-else-if="scope.row.state === 0">已禁用</el-tag>
              <el-tag type="danger" v-else-if="scope.row.state == -1">已删除</el-tag>
              <el-tag type="info" v-else>未知</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            width="100px"
            v-if="
              osg.has('SLAs,edit') ||
                osg.has('SLAs,enable') ||
                osg.has('SLAs,disable') ||
                osg.has('SLAs,remove')
            "
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="osg.has('SLAs,edit')" @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('SLAs,enable') && scope.row.state == 0"
                    @click.native="doEnable(scope.row)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('SLAs,disable') && scope.row.state == 1"
                    @click.native="doDisable(scope.row)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has('SLAs,remove')"
                    @click.native="doRemove(scope.row)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
        <el-dialog title="SLA" :visible.sync="openDetail" :close-on-click-modal="false">
          <el-form :model="formData" :rules="rules" ref="formData">
            <el-form-item label="名称" prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item
              label="工作流"
              prop="workflowDefId"
              :rules="{
                required: true,
                message: '不能为空',
                trigger: 'change'
              }"
            >
              <el-select
                v-model="formData.workflowDefId"
                :disabled="currentWorkflowDefId || formData._id ? true : false"
                @change="getFields(formData.workflowDefId)"
              >
                <template v-for="item in options.workflowDefs">
                  <el-option
                    :key="item._id"
                    :label="item.title"
                    :value="item._id"
                    v-if="item._id"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-divider>匹配条件</el-divider>
            <el-tag style="height:auto;">
              当同时满足下方所有条件时，上述流程才可以匹配到当前SLA。
              <br />
              当没有添加条件时，表示上述流程可以直接匹配到当前SLA。
            </el-tag>

            <el-table ref="conditions" :data="formData.conditions" empty-text="还没有添加条件">
              <el-table-column label="字段" prop="name">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.name" @change="scope.row.values = []">
                    <el-option
                      v-for="field in extFields"
                      :key="field._id"
                      :label="field.nameDisp"
                      :value="field.name"
                      @click.native="
                        scope.row.preset = String(field.preset);
                        $set(scope.row, 'valueOption', field.valueOption);
                      "
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="values">
                <template slot="header">
                  <span>值</span>
                  <el-tooltip effect="dark" placement="top-start">
                    <div slot="content">
                      当表单字段值为单选时：表单字段值为任意选中值即可；
                      <br />
                      当表单字段值为多选时：表单字段值不得有所选值以外的值，才能匹配。
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-select v-model="scope.row.values" multiple>
                    <template v-if="scope.row.valueOption">
                      <el-option
                        v-for="option in options[scope.row.valueOption] || []"
                        :key="option._id"
                        :label="option.label"
                        :value="option.value"
                      ></el-option>
                    </template>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60px">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    circle
                    @click="formData.conditions.splice(scope.$index, 1)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button class="c-m-t-15" @click="formData.conditions.push({})">
              添加条件
            </el-button>
          </el-form>
          <div slot="footer">
            <el-button type="primary" @click="doSave">确 定</el-button>
            <el-button @click="doInit">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SLAs',
  data() {
    window.$this = this;
    return {
      currentWorkflowDefId: '',
      name: '', //过滤器用
      searchValue: '',
      fpi: {},
      openDetail: false,
      options: { workflowDefs: [] },
      formData: {
        conditions: []
      },
      rules: this.$util.rules
    };
  },
  mounted() {
    this.getWorkflowDefs();
    this.getData();
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        workflowDefId: this.currentWorkflowDefId || '',
        conditions: []
      };
    },
    getWorkflowDefs() {
      this.osg.ajax('workflowDef/query.do', { _all: 1, 'is:state|integer#and': 1 }, res => {
        res.data.unshift({ title: '全部流程', _id: '' });
        res.data.map(item => {
          item.label = item.title;
          item.value = item._id;
        });
        this.options.workflowDefs = res.data;
      });
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#and': this.searchValue,
        'is:workflowDefId|string#and': this.currentWorkflowDefId,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('slaDef/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      if (this.$refs.formData) {
        this.$refs.formData.clearValidate();
      }
    },
    doEdit(row) {
      row.conditions = row.conditions || [];
      this.getFields(row.workflowDefId, () => {
        this.formData = row;
        this.openDetail = true;
      });
    },
    doSave() {
      if (this.osg.validate()) {
        // 校验条件字段和值是否填写完整
        let conditions = this.formData.conditions || [];
        if (conditions.length > 0) {
          for (let condition of this.formData.conditions) {
            if (!condition.name) {
              this.osg.toast('请选择条件字段！', 'warning');
              return;
            }
            if (!condition.values || condition.values.length == 0) {
              this.osg.toast('请选择条件值！', 'warning');
              return;
            }
          }
        }

        this.osg.ajax('slaDef/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEnable(row) {
      this.osg.ajax('slaDef/enable.do', { id: row._id }, () => {
        this.osg.toast('已启用');
        this.getData();
      });
    },
    doDisable(row) {
      this.osg.confirm(`是否确认禁用“${row.name}”？`, () => {
        this.osg.ajax('slaDef/disable.do', { id: row._id }, () => {
          this.osg.toast('已禁用');
          this.getData();
        });
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除${row.name}？`, () => {
        this.osg.ajax('slaDef/remove.do', { id: row._id }, () => {
          this.osg.toast('已删除');
          this.getData();
        });
      });
    },
    formatWorkflowDefId(row, column, cellValue) {
      return this.osg.codelabel('workflowDefs', cellValue);
    },
    getFields(workflowDefId, callback) {
      if (!workflowDefId) {
        this.extFields = [];
        this.formData.conditions = [];
        if (callback) callback();
        return;
      }
      // 通过工作流找到对应的关联表单
      let extId = '';
      for (let workFlowDef of this.options.workflowDefs) {
        if (workflowDefId == workFlowDef._id) {
          extId = workFlowDef.formDefId;
          break;
        }
      }
      if (!extId) {
        if (callback) callback();
        return;
      }
      this.osg.getFields(
        null,
        () => {
          if (callback) callback();
        },
        this,
        null,
        extId,
        null,
        {
          'in:type|array#and': 'radio,checkbox,select'
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.sla .left-content {
  height: 100%;
  border-right: 1px solid #dfe3eb;
  .content-group {
    padding: 10px 10px 10px 0 !important;
    .content-item {
      border-radius: 3px;
    }
  }
}
.sla .el-divider {
  margin-top: 50px;
}
</style>
